import { render, staticRenderFns } from "./ScanPerformanceCard.vue?vue&type=template&id=20b3e2ac&scoped=true&"
import script from "./ScanPerformanceCard.vue?vue&type=script&lang=js&"
export * from "./ScanPerformanceCard.vue?vue&type=script&lang=js&"
import style0 from "./ScanPerformanceCard.vue?vue&type=style&index=0&id=20b3e2ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3e2ac",
  null
  
)

export default component.exports